module.exports = __webpack_public_path__ + "media/images/riders/LOIC_BRUNI-f991456adeb04ab6dbb244b426cbadd8.png";